import React, { useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'
import { first, identity, isEmpty } from 'lodash'
import moment from 'moment'

import { Button, DatePicker } from 'carbon-components-react'
import { ChevronLeft16, ChevronRight16 } from '@carbon/icons-react'
import cn from 'classnames'

import '../index.scss'

const FORMAT = 'YYYY-MM-DD'

const CalendarArrows = ({
  valueDate,
  onDateChange,
  labelCalendar,
  minDate,
  maxDate,
  chartBackground = false,
  customDates = {}
}) => {
  const onChange = useCallback(
    (dates, key) => {
      const momentDate = moment(first(dates)).format(FORMAT)
      if (!isEmpty(customDates)) {
        onDateChange(momentDate, key)
      } else {
        onDateChange(momentDate)
      }
    },
    [valueDate, customDates]
  )

  const handleNextDay = useCallback(() => {
    const momentDate = moment(valueDate).add(1, 'days').format(FORMAT)
    onDateChange(momentDate)
  }, [valueDate])

  const handlePrevDay = useCallback(() => {
    const momentDate = moment(valueDate).subtract(1, 'days').format(FORMAT)
    onDateChange(momentDate)
  }, [valueDate])

  return (
    <div
      className={cn('amcharts-calendar', { 'bg-calendar': chartBackground })}
    >
      {isEmpty(customDates) ? (
        <Fragment>
          <DatePicker
            dateFormat='Y/m/d'
            datePickerType='single'
            value={valueDate}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
          >
            <DatePicker.Input
              placeholder='yyyy/mm/dd'
              labelText={labelCalendar}
              id='date-picker-single'
              autoComplete='off'
            />
          </DatePicker>
          <Button
            disabled={valueDate <= minDate}
            kind='ghost'
            hasIconOnly
            renderIcon={ChevronLeft16}
            onClick={handlePrevDay}
          />
          <Button
            disabled={valueDate >= maxDate}
            kind='ghost'
            hasIconOnly
            onClick={handleNextDay}
            renderIcon={ChevronRight16}
          />
        </Fragment>
      ) : (
        Object.keys(customDates).map((key) => (
          <DatePicker
            datePickerType='single'
            dateFormat='Y/m/d'
            key={key}
            value={customDates[key].value}
            onChange={(e) => onChange(e, customDates[key].key)}
            minDate={minDate}
            maxDate={maxDate}
          >
            <DatePicker.Input
              id={key}
              placeholder='yyyy/mm/dd'
              labelText={customDates[key].label}
            />
          </DatePicker>
        ))
      )}
    </div>
  )
}

CalendarArrows.propTypes = {
  onDateChange: PropTypes.func
}

CalendarArrows.defaultProps = {
  onDateChange: identity
}

export default React.memo(CalendarArrows)
